module.exports = __webpack_public_path__ + "static/media/smart-fit-white.76a088a7.svg";